import * as React from "react";
import { PageProps } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import { Layout } from "../components/common";
import { MetaData } from "../components/common/meta";
import Header from "../components/common/Header";
import { useState, useEffect } from "react";

const ClinicaPage: React.FC<PageProps> = ({ location }) => {
    // We now have 2 slide groups (each showing 4 images)
    const [currentSlide, setCurrentSlide] = useState(0);
    const totalSlides = 2;

    // Auto-advance carousel every 5 seconds
    useEffect(() => {
        const timer = setTimeout(() => {
            setCurrentSlide((prevSlide) => (prevSlide + 1) % totalSlides);
        }, 5000);
        return () => clearTimeout(timer);
    }, [currentSlide, totalSlides]);

    // Navigation handlers
    const goToPrevSlide = () => {
        setCurrentSlide(
            (prevSlide) => (prevSlide - 1 + totalSlides) % totalSlides
        );
    };

    const goToNextSlide = () => {
        setCurrentSlide((prevSlide) => (prevSlide + 1) % totalSlides);
    };

    return (
        <>
            <MetaData
                data={{}}
                location={location}
                type="website"
                title="Clínica | Renata Feldman"
                description="Conheça a Feldman Clínica de Psicologia"
            />
            <Layout>
                <Header showHero={false} />

                {/* Hero Section */}
                <header className="bg-background-alt py-16">
                    <div className="container mx-auto px-4">
                        <div className="max-w-3xl mx-auto text-center">
                            <h1 className="text-5xl font-light mb-4 text-primary">
                                Feldman Clínica de Psicologia
                            </h1>
                            <p className="text-xl text-text-light">
                                Um espaço acolhedor para cuidar da sua saúde
                                mental.
                            </p>
                        </div>
                    </div>
                </header>

                {/* Main Content */}
                <main className="container mx-auto px-4 py-0">
                    {/* Illustrative Images Carousel Section */}
                    <section className="max-w-4xl mx-auto mb-20 mt-0`">
                        <div className="rounded-lg overflow-hidden">
                            <div className="relative">
                                {/* Carousel container showing 4 images per slide */}
                                <div className="overflow-hidden h-96">
                                    <div
                                        className="flex transition-transform duration-500 ease-in-out h-full"
                                        style={{
                                            transform: `translateX(-${
                                                currentSlide * 100
                                            }%)`,
                                        }}
                                    >
                                        {/* Slide Group 1 */}
                                        <div className="min-w-full flex">
                                            <div className="w-1/4 flex items-center justify-center">
                                                <StaticImage
                                                    src="../images/clinica-1.png"
                                                    alt="Ilustração 1"
                                                    className="max-h-full max-w-full"
                                                    objectFit="contain"
                                                    placeholder="blurred"
                                                />
                                            </div>
                                            <div className="w-1/4 flex items-center justify-center">
                                                <StaticImage
                                                    src="../images/clinica-2.png"
                                                    alt="Ilustração 2"
                                                    className="max-h-full max-w-full"
                                                    objectFit="contain"
                                                    placeholder="blurred"
                                                />
                                            </div>
                                            <div className="w-1/4 flex items-center justify-center">
                                                <StaticImage
                                                    src="../images/clinica-3.png"
                                                    alt="Ilustração 3"
                                                    className="max-h-full max-w-full"
                                                    objectFit="contain"
                                                    placeholder="blurred"
                                                />
                                            </div>
                                            <div className="w-1/4 flex items-center justify-center">
                                                <StaticImage
                                                    src="../images/clinica-4.png"
                                                    alt="Ilustração 4"
                                                    className="max-h-full max-w-full"
                                                    objectFit="contain"
                                                    placeholder="blurred"
                                                />
                                            </div>
                                        </div>
                                        {/* Slide Group 2 */}
                                        <div className="min-w-full flex">
                                            <div className="w-1/4 flex items-center justify-center">
                                                <StaticImage
                                                    src="../images/clinica-5.png"
                                                    alt="Ilustração 5"
                                                    className="max-h-full max-w-full"
                                                    objectFit="contain"
                                                    placeholder="blurred"
                                                />
                                            </div>
                                            <div className="w-1/4 flex items-center justify-center">
                                                <StaticImage
                                                    src="../images/clinica-6.png"
                                                    alt="Ilustração 6"
                                                    className="max-h-full max-w-full"
                                                    objectFit="contain"
                                                    placeholder="blurred"
                                                />
                                            </div>
                                            <div className="w-1/4 flex items-center justify-center">
                                                <StaticImage
                                                    src="../images/clinica-7.png"
                                                    alt="Ilustração 7"
                                                    className="max-h-full max-w-full"
                                                    objectFit="contain"
                                                    placeholder="blurred"
                                                />
                                            </div>
                                            <div className="w-1/4 flex items-center justify-center">
                                                <StaticImage
                                                    src="../images/clinica-8.png"
                                                    alt="Ilustração 8"
                                                    className="max-h-full max-w-full"
                                                    objectFit="contain"
                                                    placeholder="blurred"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Navigation arrows */}
                                <button
                                    onClick={goToPrevSlide}
                                    className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/70 hover:bg-white/90 p-2 rounded-full shadow-md"
                                    aria-label="Imagem anterior"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-6 w-6 text-primary"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M15 19l-7-7 7-7"
                                        />
                                    </svg>
                                </button>
                                <button
                                    onClick={goToNextSlide}
                                    className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/70 hover:bg-white/90 p-2 rounded-full shadow-md"
                                    aria-label="Próxima imagem"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-6 w-6 text-primary"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M9 5l7 7-7 7"
                                        />
                                    </svg>
                                </button>

                                {/* Dots indicator */}
                                <div className="absolute bottom-4 left-0 right-0 flex justify-center space-x-2">
                                    {Array.from({ length: totalSlides }).map(
                                        (_, index) => (
                                            <button
                                                key={index}
                                                onClick={() =>
                                                    setCurrentSlide(index)
                                                }
                                                className={`w-3 h-3 rounded-full ${
                                                    currentSlide === index
                                                        ? "bg-primary"
                                                        : "bg-gray-300"
                                                }`}
                                                aria-label={`Ir para slide ${
                                                    index + 1
                                                }`}
                                            />
                                        )
                                    )}
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* About the Clinic */}
                    <section className="max-w-4xl mx-auto mb-20">
                        <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                            <div className="p-8">
                                <h2 className="text-3xl font-light mb-6 text-primary">
                                    Clínica
                                </h2>
                                <div className="prose prose-lg max-w-none">
                                    <p>
                                        Desde 2002, Renata Feldman realiza
                                        atendimento psicoterápico em seu
                                        consultório seguindo uma abordagem
                                        humanista com foco nas relações
                                        afetivas. Seu trabalho é voltado para o
                                        universo adolescente, adulto e terceira
                                        idade, além de casais.
                                    </p>
                                    <p>
                                        Com o objetivo de ampliar as
                                        possibilidades de atendimento, a
                                        psicóloga fundou, em conjunto com Clara
                                        Feldman, sua mãe e também psicóloga, uma
                                        clínica com uma equipe de profissionais
                                        sob sua supervisão.
                                    </p>
                                    <p>
                                        Nasce, assim, em 2018, a Feldman Clínica
                                        de Psicologia, preparada para atender
                                        também o público infantil e praticar
                                        valores mais acessíveis sempre que
                                        necessário.
                                    </p>
                                    <p>
                                        Visite a nossa página e agende um
                                        horário para você. Será uma alegria
                                        ajudá-lo(a) no que for preciso.
                                    </p>
                                </div>
                                {/* Image container with fixed height and centered content */}
                                <div className="flex justify-center bg-white py-8">
                                    <StaticImage
                                        src="../images/feldman-clinica.png"
                                        alt="Clínica de Psicologia"
                                        className="max-h-80 w-auto"
                                        objectFit="contain"
                                        placeholder="blurred"
                                    />
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* Hours and Contact */}
                    <section className="max-w-4xl mx-auto">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
                            <div className="bg-white rounded-lg shadow-sm p-8">
                                <h3 className="text-2xl font-light mb-4 text-primary">
                                    Endereço
                                </h3>
                                <p className="text-text-light mb-6">
                                    Rua do Ouro, 104, sala 503 – Serra
                                    <br />
                                    30220-000 – Belo Horizonte / MG
                                </p>

                                <h3 className="text-2xl font-light mb-4 text-primary">
                                    Contato
                                </h3>
                                <p className="text-text-light mb-6">
                                    Tel: (31) 3221-6233
                                    <br />
                                    Cel: (31) 97191-2552
                                    <br />
                                    Email: feldmanpsicologia@gmail.com
                                </p>

                                <h3 className="text-2xl font-light mb-4 text-primary">
                                    Modalidades
                                </h3>
                                <p className="text-text-light mb-6">
                                    Atendimento presencial e online.
                                </p>

                                <h3 className="text-2xl font-light mb-4 text-primary">
                                    Horário de funcionamento
                                </h3>
                                <p className="text-text-light">
                                    • Segunda a sexta, de 8 às 20h.
                                    <br />• Sábados, de 8 às 16h.
                                </p>

                                <h3 className="text-2xl font-light mb-4 text-primary mt-8">
                                    Site da Clínica
                                </h3>
                                <p className="text-text-light">
                                    Visite o nosso site:{" "}
                                    <a
                                        href="http://feldmanclinica.com.br"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-primary hover:text-primary-dark transition-colors"
                                    >
                                        feldmanclinica.com.br
                                    </a>
                                </p>
                            </div>
                            <div className="rounded-lg overflow-hidden shadow-sm h-80">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3751.1978307849166!2d-43.93499!3d-19.93899!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xa699dc57d4a851%3A0x883f4a697b17b0d2!2sR.%20do%20Ouro%2C%20104%20-%20Serra%2C%20Belo%20Horizonte%20-%20MG%2C%2030220-000!5e0!3m2!1spt-BR!2sbr!4v1625764302041!5m2!1spt-BR!2sbr"
                                    width="100%"
                                    height="100%"
                                    style={{ border: 0 }}
                                    allowFullScreen={true}
                                    loading="lazy"
                                    title="Localização da Clínica"
                                ></iframe>
                            </div>
                        </div>
                    </section>
                </main>
            </Layout>
        </>
    );
};

export default ClinicaPage;
